"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getErrorMessage = exports.setErrorMessages = void 0;
const local = {
    errorMessages: {
        required: "Field is required",
        username: "Use 3-30 alphanumeric characters",
        email: "Invalid email address",
        password: "Password must be between 6-40 alphanumeric characters",
        contactNumber: "Invalid phone number. You may use up to 17 characters, including numbers 0-9 and characters +, (, ), and -.",
        website: "Please enter a valid website",
    },
};
function setErrorMessages(messages) {
    local.errorMessages = Object.assign(Object.assign({}, local.errorMessages), messages);
}
exports.setErrorMessages = setErrorMessages;
function getErrorMessage(name) {
    return local.errorMessages[name] || "";
}
exports.getErrorMessage = getErrorMessage;
//# sourceMappingURL=errors.js.map